export default [
  {
    key: 'bundle',
    path: 'bundle',
    cover: 'a8a87de9-eb36-4cf5-9e1c-45df439adff8.jpeg',
    name: 'Fanatical Bundles',
  },
  {
    key: 'vr',
    path: 'vr-games',
    cover: '3716de7f-5581-47d2-a2fe-f2c6d5a362f6.jpeg',
    name: 'VR Games',
  },
  {
    key: 'virtual reality',
    path: 'vr-games',
    cover: '3716de7f-5581-47d2-a2fe-f2c6d5a362f6.jpeg',
    name: 'Virtual Reality Games',
  },
  {
    key: 'ebook',
    path: 'bundle/books',
    cover: '7e807a28-afbf-4358-b0fd-952a1f54ce3c.jpeg',
    name: 'eBooks',
  },
  {
    key: 'book',
    path: 'bundle/books',
    cover: '7e807a28-afbf-4358-b0fd-952a1f54ce3c.jpeg',
    name: 'eBooks',
  },
  {
    key: 'mac',
    path: 'mac-games',
    cover: '43285ba8-4d79-44ad-b736-7d13e660b7ca.jpeg',
    name: 'Mac Games',
  },
  {
    key: 'linux',
    path: 'linux-games',
    cover: '0369848d-ab9e-4a46-b475-de39ee382ebd.jpeg',
    name: 'Linux Games',
  },
  {
    key: 'steam deck',
    path: 'steam-deck-games',
    cover: '98e3d99b-50b0-46a1-8dd1-40ac31a04e71.jpeg',
    name: 'Steam Deck Games',
  },
  {
    key: 'black friday',
    path: 'black-friday',
    cover: 'f219b9b2-d4db-41ae-be25-7d4cbd657c9a.jpeg',
    name: 'Black Friday',
  },
  {
    key: 'cyber monday',
    path: 'cyber-monday',
    cover: '345bfa3c-9ea4-49df-bd01-5018c5d0ff50.jpeg',
    name: 'Cyber Monday',
  },
].map(r => ({ ...r, isFixed: true }));
